import patientIntakeMobile from "../../../image/health/aimma-patient/patient-intake-mobile.png";
import { HealthLang } from "../healthTypes";

const PREVIEW_LABEL = {
    En: "Patient intake mobile interface preview",
    Zh: "病患問診手機介面預覽",
    Jp: "患者インテークモバイル画面",
} as const;

interface PatientIntakeMobilePreviewProps {
    lang: HealthLang;
}

export function PatientIntakeMobilePreview({ lang }: PatientIntakeMobilePreviewProps) {
    const alt = PREVIEW_LABEL[lang] ?? PREVIEW_LABEL.En;

    return (
        <div
            className="relative flex w-full min-w-[9rem] justify-start text-left [text-align:left]"
            role="img"
            aria-label={alt}
        >
            <div className="relative h-[17.5rem] w-auto max-w-[9.75rem] shrink-0 overflow-hidden rounded-[1.35rem] border-[2.5px] border-grey-900 bg-grey-900 shadow-[0_14px_32px_rgba(14,116,144,0.16)] aspect-[9/19.5]">
                <img
                    src={patientIntakeMobile}
                    alt=""
                    aria-hidden="true"
                    className="h-full w-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                />
                <div
                    className="pointer-events-none absolute left-1/2 top-2 z-[1] h-2.5 w-10 -translate-x-1/2 rounded-full bg-black/85"
                    aria-hidden="true"
                />
            </div>
        </div>
    );
}
